import Vue from 'vue'
import clone from 'clone'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { PAYTMETH_INIT_LOADING, PAYTMETH_INIT_SUCCESS, PAYTMETH_INIT_FAIL, PAYTMETH_BANKLIST } from '@/store/types'
export const initialState = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  defPayBankList: []
}

const getters = {

}

const mutations = {
  [PAYTMETH_INIT_LOADING](state, err) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [PAYTMETH_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [PAYTMETH_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [PAYTMETH_BANKLIST](state, data) {
    Vue.set(state, 'defPayBankList', data)
  }
}

const actions = {
  async paytMethManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.paytMethManagement
    commit(PAYTMETH_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      let apiURL = commitResult.menu.getDefPayBankList
      if (apiURL) {
        try {
          const result = await http.get(apiURL)
          commit(PAYTMETH_BANKLIST, result.data.data.defPayBankList)
        } catch (err) {
          throw err
        }
      }
      commit(PAYTMETH_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(PAYTMETH_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
